import { render, staticRenderFns } from "./ServiceFeeStatementDetailView.vue?vue&type=template&id=b4db5fb0&"
import script from "./ServiceFeeStatementDetailView.vue?vue&type=script&lang=js&"
export * from "./ServiceFeeStatementDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFeeStatementDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports